export const AboutUsSlug = 'ueber-uns';

export function getAboutUsUrl(dealerSlug: string): string {
    return `/${dealerSlug}/${AboutUsSlug}`;
}

export function getSubDealerAboutUsUrl(dealerSlug: string, subDealerSlug: string): string {
    return `/${dealerSlug}/${subDealerSlug}`;
}
